import React from 'react'
import PropTypes from 'prop-types'
import { PersonalDetails } from 'LiveBoard/components/shared/SellerCard/PersonalDetails'

const ClosedCard = ({ config, lead, themeColorHex, seller }) => {
  const teaserStyle={ backgroundColor: themeColorHex, borderColor: themeColorHex }
  return (
    <div className="card closed">
      <PersonalDetails seller={seller} />
    </div>
  )
}

ClosedCard.propTypes = {
  config: PropTypes.object.isRequired,
  lead: PropTypes.object.isRequired,
  themeColorHex: PropTypes.string.isRequired,
  seller: PropTypes.object.isRequired
}

export default ClosedCard
